import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import styles from './product.css';

import { Product } from './';

class Products extends Component {
  componentDidMount() {}

  render() {
    return (
      <div>
        {this.props.products.map(product => {
          return (
            <div styleName="product" key={product.name}>
              <Product product={product} />
            </div>
          );
        })}
      </div>
    );
  }
}

Products.propTypes = {
  products: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  products: state.softwareFeed.products,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(Products, styles));
